export default __webpack_public_path__ + "static/media/H1006.1.253223f8.mp3";